import React from "react";
import { toast } from "react-toastify";
import Button, { ButtonThemes } from "../../../../ui-components/button/button";
import { formatJson } from "../constants";

export interface JsonBlockProps {
  title: string;
  value: unknown;
  emptyText?: string;
}

const JsonBlock: React.FC<JsonBlockProps> = ({ title, value, emptyText = "Nothing recorded." }) => {
  const text = formatJson(value);

  const onCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.info("Copied to clipboard."))
      .catch(() => toast.error("Unable to copy to the clipboard."));
  };

  return (
    <div className="xgs-invoice-factoring__json-block">
      <div className="xgs-invoice-factoring__json-title">
        <span>{title}</span>
        {text && (
          <Button theme={ButtonThemes.transparent} type="button" onClick={onCopy}>
            Copy
          </Button>
        )}
      </div>
      {text ? (
        <pre className="xgs-invoice-factoring__json">{text}</pre>
      ) : (
        <div className="xgs-invoice-factoring__muted">{emptyText}</div>
      )}
    </div>
  );
};

export default JsonBlock;
